import React, { useState } from "react";
import { HiOutlineMenu } from "react-icons/hi";
import { FaFingerprint, FaUser } from "react-icons/fa";
import { Link, NavLink } from 'react-router-dom';
import { MdClose } from "react-icons/md";
import Popuplogo from "../../assets/images/logo_icon.png";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { apiCall, getCurrentUser } from "../../Api/auth";
import "./Header.css";
import "../../assets/css/event.css";
import { useEffect } from "react";
import { API_URL } from "../../Api/config";
import { BsGrid, BsPower } from "react-icons/bs";
import { FiChevronDown } from "react-icons/fi";
import { IoClose } from "react-icons/io5";
import { logout } from "../../Api/auth";

function HeaderNew() {

    const [password, setPassword] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [apicall, setApicall] = React.useState(false);
    const [errors, setErrors] = React.useState([]);
    const [userdata, setUserdata] = React.useState(null);

    useEffect(() => {
        // setUserdata(getCurrentUser());
        const fetchUserData = async () => {
            try {
                const userData = await getCurrentUser();
                if (userData) {
                    setUserdata(userData);
                } else {
                    // Handle case where user data is missing or incomplete
                    console.error('User data is missing or incomplete.');
                }
            } catch (error) {
                // Handle any errors that occur during data fetching
                console.error('Error fetching user data:', error);
            }
        };

        fetchUserData();
    }, []);

    const toggle = () => {
        document.getElementById("navbar").classList.toggle("navbar-mobile");
        if (document.getElementById("navbar").classList.contains("navbar-mobile")) {
            document.getElementsByClassName("menu-icon")[0].style.display = "none";
            document.getElementsByClassName("close-icon")[0].style.display = "block";
        }
        else {
            document.getElementsByClassName("menu-icon")[0].style.display = "block";
            document.getElementsByClassName("close-icon")[0].style.display = "none";
        }

    }

    const getErrorByField = (errors, field) => {
        return errors.filter(function (item) {
            if (item.field === field) { return { "field": item.field, "message": item.message } }
        });
    }

    const [show, setShow] = useState(false);
    const [validated, setValidated] = useState(false);

    const handleSubmit = async (event) => {
        setApicall(true);
        apiCall(API_URL + "user/login", "POST", { email: email, password: password }, event).then((res) => {
            if (!res.data.status) { setErrors(res.data.error); }
            else {
                localStorage.setItem("user", JSON.stringify(res.data.data));
                const role_id = res.data.data.user.role_id;
                // window.location.href = "/dashboard"
                if (role_id === 4) {
                    window.location.href = "/user-dashboard"
                } else {
                    window.location.href = "/dashboard"
                }
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
        });
        setValidated(true);
    }

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);



    useEffect(() => {
        console.log("getCurrentUser", getCurrentUser());
    }, [errors]);

    // const userData = localStorage.getItem("user");
    // const userJson = JSON.parse(userData);

    // const roleId = userJson.user?.role_id

    const userData = localStorage.getItem("user");
    let roleId;
    if (userData) {
        const userJson = JSON.parse(userData);

        roleId = userJson.user?.role_id
    } else {
        roleId = null
    }



    const toggleLable = () => {
        document.getElementsByClassName("sec-center")[0].classList.toggle("show");
    }

    const [scrolling, setScrolling] = useState(false);
    const [scrollTop, setScrollTop] = useState(0);

    const handleScroll = () => {
        setScrollTop(document.documentElement.scrollTop);
        setScrolling(document.documentElement.scrollTop > 100);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [scrollTop]);

    return (
        <>
            <header id="header" className="header bg-remove-head fixed-top menu container-fluid container-xxl">
                <div className="d-flex align-items-center justify-content-between">
                    <a href="/about-us" className="logo d-flex align-items-center">
                        <span><img src={require("../../assets/images/logo_icon.png")} /></span>
                    </a>
                    <NavLink to="/about-us" exact activeClassName="active" className="btn cen_men nav_footer event-btn-header">Homepage</NavLink>
                  
                </div>
            </header>

         


           
        </>
    );
}

export default HeaderNew;